import { useMutation, useQueryClient } from "@tanstack/vue-query";
import TemplateFolder from "@/services/template/template-folder";

export function useDeleteTemplateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await TemplateFolder.deleteTemplateFolder(id);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete template folder");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["templateFolders"] });
    },
  });
}
